import { getHasWorkspaces, getWorkspace } from 'conversations/utils/workspaceHelper'
const DEFAULT_DISPLAY_NAME = 'Site visitor'

export const getDisplayName = (customer?: {
  name?: string
  email?: string
  status?: string
}): string => {
  if (!customer) {
    return DEFAULT_DISPLAY_NAME
  }

  const displayName = customer.name || customer.email

  if (displayName && customer.status === 'ARCHIVED') {
    return `${displayName} [deleted]`
  }

  return displayName || DEFAULT_DISPLAY_NAME
}

export const tryGetWorkspaceName = (workspaceId: string) => {
  if (getHasWorkspaces()) {
    return getWorkspace(workspaceId)?.name || 'Default'
  } else {
    return undefined
  }
}

export const getTeamNameWithWorkspace = (team: { name: string; workspaceId: string }): string => {
  return `${team.name} ${tryGetWorkspaceName(team.workspaceId) || ''}`
}
